module.exports = {
          srcSet: __webpack_public_path__ + "3a2216501185573e9e5721f327c73e3c-2607.png"+" 2607w",
          images:[ {path: __webpack_public_path__ + "3a2216501185573e9e5721f327c73e3c-2607.png",width: 2607,height: 2053}],
          src: __webpack_public_path__ + "3a2216501185573e9e5721f327c73e3c-2607.png",
          toString:function(){return __webpack_public_path__ + "3a2216501185573e9e5721f327c73e3c-2607.png"},
          
          width: 2607,
          height: 2053
        }